<template>
  <div id="upload_main">

    <div id="upload_zone">
      <div class="outer">
        <span>出品用ファイルのzipファイルをアップロード</span>
        <div class="drop_zone"
          :class="{'enter': isEnter}"
          @dragenter="dragEnter"
          @dragleave="dragLeave"
          @dragover.prevent
          @drop.prevent="setDropFile">

          <button class="btn btn-primary" @click='pushButton()'>zipファイルをドラッグ&ドロップ</button>
          <input @change='fileChange' id="file_read" style="display: none;" type="file" />
          <div>
            <div v-if="resizeImageProgress != 0">
              <label>画像圧縮中・・・</label>
              <progress v-bind:value="resizeImageProgress" max="100"></progress>
            </div>
            <div v-if="progressValue != 0">
              <label>データアップロード中・・・</label>
              <progress v-bind:value="progressValue" max="100"></progress>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="grid-table-contents">
      <div v-if="true" class="grid-table-scroll">
        <table class="table table-striped table-sm table-hover sticky_table">
          <thead>
            <tr class="table-primary">
              <th><button v-if="checkedRecords.length == 1" class="btn btn-danger btn-sm reset-button-right" @click='resetButton()'>チェックしたデータを削除</button></th>
              <th class="col-header-send">日付</th>
              <th class="col-header-file">zipファイル</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(rowItem, rowIndex) in records"
              v-bind:key="rowIndex"
              v-bind:id = "'list' + rowItem.json.id">
              <td><input type="checkbox" id="rowItem.json.id" v-model="checkedRecords" :value="rowItem.json.id"></td>
              <td class="col-send">{{rowItem.json.created_at}}</td>
              <td class="col-file">{{rowItem.json.name}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else>
        <span v-if="apiComplete">対象データがありません</span>
        <span v-else class="visually-hidden">Loading...</span>
      </div>
    </div>

  </div>
</template>

<script>
import { ref, defineComponent, onMounted } from 'vue'
import axios from 'axios'
import resizeImage from '@/js/resizeImage.js'
import base64FromBlob from '@/js/base64FromBlob.js'
import zipToArrayBuffer from '@/js/zipToArrayBuffer.js'

export default defineComponent({
  setup () {
    const records = ref([])
    const checkedRecords = ref([])
    const isEnter = ref(false)
    const progressValue = ref(0)
    const resizeImageProgress = ref(0)
    const uploading = ref(false)

    const dataURI = ref('')

    const dragEnter = () => {
      isEnter.value = true
    }

    const dragLeave = () => {
      isEnter.value = false
    }

    const pushButton = () => {
      const button = document.getElementById('file_read')
      button.click()
    }

    const resetButton = () => {
      if (checkedRecords.value.length === 1) {
        if (confirm('チェックしたデータを削除してもよろしいですか?')) {
          axios.post('/api/putup/delete_id', { delete_id: checkedRecords.value[0] })
            .then((response) => {
              checkedRecords.value = []
              setListItems()
              alert('チェックしたデータを削除しました')
            })
        }
      } else {
        alert('削除チェックは1件ずつ実行してください')
      }
    }

    const uploadZip = (zipFile) => {
      zipToArrayBuffer(zipFile)
        .then((bytes) => {
          resizeImageProgress.value = 0
          resizeImage(bytes, resizeImageProgress)
            .then((resizeBlob) => {
              base64FromBlob(resizeBlob)
                .then((base64Data) => {
                  resizeImageProgress.value = 0
                  uploading.value = true
                  axios.post('/api/putup/upload', { data: base64Data }, { onUploadProgress: onUpload })
                    .then((response) => {
                      uploading.value = false
                      progressValue.value = 0
                      setListItems()
                      alert(zipFile.name + 'を登録完了しました')
                    })
                  isEnter.value = false
                })
            })
        })
    }

    const onUpload = (e) => {
      // プログレスバーを計算して変更
      progressValue.value = Math.floor((e.loaded * 100) / e.total)
    }

    const fileChange = (e) => {
      const files = e.target.files
      uploadZip(files[0])
    }
    const setDropFile = () => {
      const files = event.dataTransfer.files
      if (files.length > 0) {
        uploadZip(files[0])
      }
    }

    const setListItems = () => {
      axios.get('/api/putup/get_zipfile_records')
        .then((res) => {
          // console.log(res.data)
          records.value = res.data.records
        })
    }

    onMounted(() => {
      setListItems()
    })

    return {
      isEnter,
      dragEnter,
      dragLeave,
      pushButton,
      resetButton,
      fileChange,
      setDropFile,
      uploading,
      progressValue,
      records,
      checkedRecords,
      dataURI,
      resizeImageProgress
    }
  }
})
</script>

<style lang="scss" scoped>
#upload_main {
  position: relative;
  width: 100%;
  height: 100%;

  .resize-image {
    position: absolute;
    right: 0;
    bottom: 10%;
    width: 10%;
    height: 10%;
  }

  .test-image {
    position: absolute;
    right: 0;
    bottom: 0;
    width: auto;
    height: auto;
  }

  #upload_zone {
    width: 50%;
    height: auto;
    margin: 1.5rem auto;

    .outer {
      top: 10%;
      position:relative;

      .drop_zone {
        align-items: center;
        background-color: #f5f5f5;
        width: 50%;
        border: 2px dashed rgba(0,0,0,0.12);
        border-radius: 6px;
        font-size: 15px;
        padding: 20px 24px 20px 24px;
        margin: 0 auto;
        vertical-align: middle;
      }

      .enter {
        border: 10px dotted powderblue;
      }
    }
  }

  .grid-table-contents {
    position: relative;
    width: 70vw;
    height: 70vh;
    margin: 3vh auto;

    .grid-table-scroll {
      overflow-y: scroll;
      height: 100%;
      width: 100%;
      font-size: medium;

      .sticky_table {
        width: 100%;

        thead th {
          /* 縦スクロール時に固定する */
          position: -webkit-sticky;
          position: sticky;
          top: 0;
          /* tbody内のセルより手前に表示する */
          z-index: 1;
        }
        input[type="checkbox"]{
          transform: scale(2);
        }

        .reset-button-right {
          margin: 0 0 0 auto;
        }

      }
    }
  }

}

</style>
